function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FEFEFE",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M46.827 44.737V12.152H34.722V0H29.76C12.238 0 0 10.886 0 26.472V74.38h12.167V44.065h12.66V31.898h-12.66v-5.426c0-4.372 1.573-7.86 4.675-10.366 3.143-2.54 7.73-3.939 12.918-3.939h4.9v32.57c0 16.41 13.35 29.76 29.76 29.76h1.495V62.33H64.42c-9.7 0-17.593-7.892-17.593-17.593"
}), React.createElement("path", {
  d: "M90.746 62.174c-10.436 0-18.927-8.49-18.927-18.927 0-10.436 8.49-18.927 18.927-18.927 10.436 0 18.927 8.491 18.927 18.927 0 10.437-8.49 18.927-18.927 18.927m0-50.02c-17.145 0-31.094 13.948-31.094 31.093 0 17.146 13.949 31.094 31.094 31.094 17.145 0 31.094-13.948 31.094-31.094 0-17.145-13.949-31.094-31.094-31.094"
}));

var SvgFloLogo = function SvgFloLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 122,
    height: 75,
    viewBox: "0 0 122 75",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFloLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flo-logo.98941ada.svg";
export { ForwardRef as ReactComponent };